export default __webpack_public_path__ + "static/media/cats_pool.b028ea90.PNG";